const style = (theme) => {
  const output = {
    wrapper: {
      extend: theme.wrapper,
    },
    container: {},
    card: {
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      borderRadius: 20,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      display: 'flex',
      justifyContent: 'flex-end',
      '-webkit-backface-visibility': 'hidden',
      '-moz-backface-visibility': 'hidden',
      '-webkit-transform': 'translate3d(0, 0, 0)',
      '-moz-transform': 'translate3d(0, 0, 0)',
    },
    title: {
      color: theme.colors[3],
      fontSize: 39,
      marginBottom: 60,
      width: '100%',
      '& p': {
        margin: 0,
      },
    },
    list: {
      width: '100%',
    },
    text: {
      color: theme.colors[0],
      fontSize: 16,
    },
    cardImage: {
      position: 'absolute',
      zIndex: 1,
      width: '70%',
      height: '100%',
      top: 0,
      left: 0,
    },
    cardInfo: {
      position: 'relative',
      zIndex: 2,
      backgroundColor: theme.colors[1],
      width: '35%',
      padding: 80,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      lineHeight: 1,
      borderRadius: 20,
      overflow: 'hidden',
    },
    itemList: {
      display: 'flex',
      justifyContent: 'flex-start',
      '& $title': {
        fontSize: 18,
        marginBottom: 20,
      },
      '&:not(:last-child)': {
        marginBottom: 35,
      },
      marginBottom: 50,
    },
    itemListDot: {
      position: 'relative',
      marginRight: 30,
      width: 8,
      height: 8,
      '& > span': {
        content: '""',
        position: 'absolute',
        zIndex: 2,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        top: 0,
        left: 0,
        background: theme.colors[3],
        marginTop: 6,
        marginLeft: 10,
        '&:before': {
          content: '""',
          position: 'absolute',
          zIndex: 0,
          display: 'block',
          height: '100%',
          width: '100%',
          borderRadius: '50%',
          top: 0,
          left: 0,
          animation: '$pulse1 1.25s ease-in infinite',
        },
      },
    },
    '@keyframes pulse1': {
      '0%': {
        boxShadow: '0 0 0 0 rgba(227, 82, 5, 0.2)',
      },
      '100%': {
        boxShadow: '0 0 0 15px rgba(227, 82, 5, 0)',
      },
    },
    itemListContent: {
      flex: 1,
    },
  }

  output[theme.mediaInverse.md] = {
    card: {
      flexDirection: 'column',
    },
    cardImage: {
      width: '100%',
      position: 'relative',
      '&:before': {
        content: '""',
        width: '100%',
        paddingBottom: '56.25%',
        display: 'block',
      },
    },
    cardInfo: {
      width: '100%',
    },
  }

  output[theme.mediaInverse.sm] = {
    cardInfo: {
      padding: 40,
    },
  }

  return output
}
export default style
